import { useEffect, useState } from 'react'
import { api } from '../api/client.ts'
import { onServerEvent } from '../realtime/socket.ts'

/**
 * ШАПКА С ЗАКРЕПЛЁННЫМИ
 *
 * Закреплённых бывает несколько: в семейной группе разом висят и адрес
 * дачи, и список вещей в поездку, и время сбора. Одно закрепление
 * означало бы, что каждое следующее стирает предыдущее.
 *
 * Показываем по одному, а нажатие перебирает их по кругу и подводит
 * к самому сообщению. Полоска сбоку говорит, сколько их всего и на
 * котором ты сейчас: без неё непонятно, откуда взялось другое.
 */

type Pin = {
  id: string
  body: string | null
  authorName: string | null
  createdAt: string
  pinnedAt: string
}

export function PinnedBar({
  chatId,
  onJump,
}: {
  chatId: string
  onJump: (messageId: string) => void
}) {
  const [pins, setPins] = useState<Pin[]>([])
  const [index, setIndex] = useState(0)

  const load = () => {
    api<{ pins: Pin[] }>(`/api/chats/${chatId}/pins`)
      .then((data) => {
        setPins(data.pins)
        setIndex((current) => (current < data.pins.length ? current : 0))
      })
      .catch(() => setPins([]))
  }

  useEffect(load, [chatId])

  // Закрепить мог и собеседник — тогда шапка должна появиться сама
  useEffect(() => {
    return onServerEvent((event) => {
      if (event.type === 'chat:pinned' && event.chatId === chatId) load()
    })
  }, [chatId])

  if (pins.length === 0) return null

  const pin = pins[Math.min(index, pins.length - 1)]!

  const unpin = async () => {
    await api(`/api/messages/${pin.id}/pin`, { method: 'POST', body: { pinned: false } })
    load()
  }

  return (
    <div className="pinned-bar">
      {/* Столбик из чёрточек: видно и сколько закреплено, и где ты */}
      {pins.length > 1 && (
        <span className="pinned-rail" aria-hidden="true">
          {pins.map((item, position) => (
            <span
              key={item.id}
              className={'pinned-tick' + (position === index ? ' is-here' : '')}
            />
          ))}
        </span>
      )}

      <button
        className="pinned-main"
        onClick={() => {
          onJump(pin.id)
          // Следующее нажатие покажет следующее закреплённое
          if (pins.length > 1) setIndex((current) => (current + 1) % pins.length)
        }}
      >
        <span className="pinned-text">
          <span className="pinned-title">
            {pins.length > 1 ? `Закреплено ${index + 1} из ${pins.length}` : 'Закреплено'}
            {pin.authorName ? ` · ${pin.authorName}` : ''}
          </span>
          <span className="pinned-body">{pin.body ?? 'вложение'}</span>
        </span>
      </button>

      <button className="pinned-off" onClick={() => void unpin()} title="Открепить">
        ✕
      </button>
    </div>
  )
}
